import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { DialogRef } from "../dialog/dialog-ref";
import { DIALOG_DATA } from "../dialog/dialog-tokens";

@Component({
    selector: "app-md-confirmation-message-v1",
    templateUrl: "./md-confirmation-message-v1.component.html",
    styleUrls: ["./md-confirmation-message-v1.component.scss"],
    standalone: false
})
export class MdConfirmationMessageV1Component implements OnInit {
  @Input() public opened = false;
  @Input() public data: any;
  @Input() public message: any;

  @Output() closeDialogEvent = new EventEmitter<any>();

  public titlebarTitle = "Confirmation";
  public titlebarCssClass = "modal-title-red";
  public dlgWidth: number = 600;
  public dlgMaxHeight: string = '80%';

  constructor(
    private dialogRef: DialogRef,
    @Inject(DIALOG_DATA) public inputData: v1DlgInputArgs
  ) {}

  ngOnInit(): void {
    if (this.inputData) {
      this.opened = this.inputData.opened;
      this.dlgWidth = this.inputData.dialogWidth;
      this.data = this.inputData.data;
      this.message = this.inputData.message;
    }
  }

  public close(status: any) {
    this.opened = false;

    let savParamters: dlgModelArgs = {
      status: status,
      data: this.data,
    };
    this.closeDialogEvent.emit(savParamters);
    this.dialogRef?.close(savParamters);
  }

  public open() {
    this.opened = true;
  }
}

export interface v1DlgInputArgs {
  opened: boolean;
  dialogWidth: number;
  data: any;
  message: any;
}

export interface dlgModelArgs {
  status: string;
  data: any; //ProposalEntity[]
}
